// Web no-op: expo-notifications push tokens are not supported on web, and the
// platform split keeps the module out of the web bundle entirely.
export async function registerForPushNotificationsAsync(): Promise<
  string | null
> {
  return null;
}

export function addPushTokenRefreshListener(
  _callback: (token: string) => void
): () => void {
  return () => {};
}

export function getLastNotificationUrl(): string | null {
  return null;
}

export function addNotificationResponseListener(
  _callback: (url: string) => void
): () => void {
  return () => {};
}
